import { normalizeDecimal } from "../../../../utils/decimalInput";

export type BmiInputKind = "height" | "weight";
export type BmiInputCheck = "ok" | "soft" | "hard";

/** Height in cm, weight in kg. Soft bounds are inclusive (150 cm is soft). */
export const BMI_INPUT_LIMITS: Record<BmiInputKind, { hard: [number, number]; soft: [number, number] }> = {
  height: { hard: [130, 220], soft: [150, 205] },
  weight: { hard: [40, 250], soft: [50, 200] },
};

/** Takes the typed text, so "0" or "abc" count as hard, not as empty. */
export const checkBmiInput = (text: string, kind: BmiInputKind): BmiInputCheck => {
  const raw = normalizeDecimal(text);
  if (!raw) return "ok";
  const value = Number(raw);
  const { hard, soft } = BMI_INPUT_LIMITS[kind];
  if (!(value >= hard[0] && value <= hard[1])) return "hard";
  if (value <= soft[0] || value >= soft[1]) return "soft";
  return "ok";
};

/** Typed cm/kg fields with BMI_INPUT_LIMITS apply where the rule offers no imperial units (DE); the UK keeps its sliders. */
export const usesBmiInputLimits = (question: any): boolean => {
  const heightRule = question?.answersGroup?.recipe?.validation_rule;
  const weightRule = question?.answersGroup?.children?.[0]?.recipe?.validation_rule;
  return !heightRule?.allow_imperial_height && !weightRule?.allow_imperial_weight;
};
